import {
  StockCount,
  StockCountLine,
} from "@towersystems/roam-common/lib/generated-types";
import { createContext } from "react";

export type StockCountCompletedContextType = {
  stockCount: StockCount;
  stockCountLines: StockCountLine[];
};

export const StockCountCompletedContext = createContext<
  StockCountCompletedContextType | undefined
>(undefined);
